<script>
import AppVideoPlayer from "./AppVideoPlayer.vue";
import { mapState } from "vuex";

//eslint-disable-next-line
export default {
  components: {
    AppVideoPlayer,
  },
  data() {
    return {
      zIndex: 100,
      observer: null,
      playingVideo: null,
    };
  },
  props: {
    activeVideo: {
      type: String,
      default: "video1",
    },
    slides: {
      type: Array,
      default: () => null,
    },
  },
  created() {
    this.observer = new IntersectionObserver(this.playVideo, {
      threshold: 0,
    });
  },

  mounted() {
    this.$refs.video1[0].$refs.video1.style.zIndex = this.zIndex;
    this.setObserver();
  },
  watch: {
    modalAttr: {
      handler() {
        if (this.modalAttr.isModalOpen === true && this.playingVideo !== null) {
          this.playingVideo.pause();
        } else if (
          this.modalAttr.isModalOpen === false &&
          this.playingVideo !== null
        ) {
          this.playingVideo.play();
        }
      },
      deep: true,
    },
    activeVideo: function() {
      this.zIndex = this.zIndex + 1;
      const videosArray = JSON.parse(JSON.stringify(this.slides));
      videosArray.forEach((slide) => {
        this.$refs[slide.id][0].$refs[slide.id].classList.remove("active");
      });
      const currentVideo = this.$refs[this.activeVideo][0].$refs[
        this.activeVideo
      ];
      this.playingVideo = currentVideo;
      currentVideo.classList.add("active");
      currentVideo.style.zIndex = this.zIndex;
      currentVideo.currentTime = 0;
      currentVideo.play();
    },
  },
  computed: {
    ...mapState(["modalAttr"]),
  },
  methods: {
    setObserver() {
      const videosArray = JSON.parse(JSON.stringify(this.slides));
      videosArray.forEach((slide) => {
        this.observer.observe(this.$refs[slide.id][0].$refs[slide.id]);
      });
    },
    playVideo(entries) {
      const vm = this;
      entries.forEach(function(video) {
        if (video.isIntersecting === true) {
          for (const source in video.target.children) {
            const videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
            video.target.load();
            if (video.target.dataset.id === vm.activeVideo) {
              video.target.play();
              vm.playingVideo = video.target;
            }
          }
        } else {
          //TODO validate if the video is playable then pause it
          video.target.pause();
          video.currentTime = 0;
        }
      });
    },
    updatePlayer() {
      this.zIndex = this.zIndex + 1;
      // this.setObserver();
    },
  },
};
</script>
<template>
  <div class="containerVideo">
    <AppVideoPlayer
      v-for="video in slides"
      :video="video"
      :key="video.id"
      :ref="video.id"
    />
  </div>
</template>

<style lang="scss" scoped>
.containerVideo {
  --vSize: 100%;
  position: relative;
  height: var(--vSize);
  object-fit: cover;
  margin: 0;
}
video {
  width: auto;
  height: var(--vSize);
  object-fit: cover;
  aspect-ratio: 16/9;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.active {
  animation: fadeIn 0.5s ease-in-out;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/VideoTogglePlayer.vue